import { Box } from "@mui/material";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import { useMemo, CSSProperties } from "react";
import { palette } from "../../../styles/theme";

interface Props {
  images: string[];
  sides: string[];
  onSlideChange?: (side: string) => void;
}

const SwipableImageSlider = ({ images, sides, onSlideChange }: Props) => {
  const height = useMemo(() => {
    return `calc(100dvh - 48px - 70px - 24px - 145px)`;
  }, []);

  return (
    <Box
      height={height}
      sx={{
        overflow: "hidden",
        minHeight: "0",
        maxHeight: "100%",
        "& .swiper-pagination-bullet": {
          width: "6px",
          height: "6px",
          backgroundColor: palette.grey.darkerGrey,
        },
        "& .swiper-pagination-bullet-active": {
          width: "7px",
          height: "7px",
          backgroundColor: palette.brand.secondary,
        },
      }}
    >
      <Swiper
        slidesPerView={"auto"}
        centeredSlides={true}
        spaceBetween={0}
        pagination={{
          clickable: true,
          bulletActiveClass: "swiper-pagination-bullet-active",
          bulletClass: "swiper-pagination-bullet",
        }}
        initialSlide={0}
        modules={[Pagination]}
        style={
          {
            height: "100%",
          } as CSSProperties
        }
        onSlideChange={(swiper: SwiperType) => {
          onSlideChange?.(sides[swiper.activeIndex]);
        }}
      >
        {images.map((image, index) => (
          <SwiperSlide
            key={index}
            style={{
              maxHeight: "calc(100% - 32px)",
              display: "flex",
              maxWidth: "calc(100vw - 24px)",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              maxHeight={"calc(100% - 32px)"}
              maxWidth={"calc(100% - 32px)"}
              sx={{ objectFit: "contain" }}
              src={image}
              alt={sides[index]}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default SwipableImageSlider;
